/* eslint-disable prefer-rest-params */
export const ReplaceDataLabelsWithDot = (H:any) => {
  H.wrap(H.Series.prototype, 'drawDataLabels', function(proceed:any) {
    // tslint:disable-next-line
    const series:any = this;
    if (series.options.hideLabels) {
      const selected = series.data.find(item => item.selected);
      if (selected) {
        const x = selected.plotX + series.xAxis.pos;
        const y = selected.plotY + series.yAxis.pos;
        series.chart.renderer.circle(x, y, 10).attr({
          fill: selected.dataLabels?.color,
          zIndex: 100
        }).add();
      }
    } else {
      proceed.apply(series, Array.prototype.slice.call(arguments, 1));
    }
  });
};
